<template>
  <article id="article-market">
    <div :class="[ shouldStick ? 'period-sticky-top' : 'period-remove-sticky-top']">
      <div class="select-period-row">
        <period-navigation
          :arrPeriod="arrPeriod"
          :alias="`period`"
          @select-data="insertQs"
          :defaultItem.sync="defaultPeriod"
          data-action="change_index_period"
          :slidePerPage="6"
        />
      </div>
    </div>

    <section id="section-list-indice" v-if="sortData.length">
      <ListMarket
        data-action="open_index"
        data-assettype="indices"
        data-list="market_index"
        :items="sortData"
        :type="'indice'"
      />
    </section>

    <!-- Search Loading -->
    <section id="search-loading" v-else>
      <i class="loading fas fa-spinner-third fa-spin"></i>
    </section>
  </article>
</template>

<script>
import GlobalMarketFunc from "../../../../components/mixins/global-market-functions"
import ListMarket from "../../../../components/miniapp/market/List"
import PeriodNavigation from "../../../../components/miniapp/global/PeriodNavigation.vue"

import _orderBy from "lodash/orderBy"
import { mapGetters, mapActions } from "vuex"
export default {
  name: "",
  components: {
    ListMarket,
    PeriodNavigation
  },
  data() {
    return {
      shouldStick: false,
      arrPeriod: ["1D", "1M", "6M", "1Y", "3Y", "5Y"],
      objQuery: {},
      defaultPeriod: "1Y"
    }
  },
  mixins: [GlobalMarketFunc],
  computed: {
    ...mapGetters("indice", ["getIndiceRanking"]),
    sortData() {
      return _orderBy(
        this.getIndiceRanking,
        indice => {
          return new Number(indice.percent)
        },
        ["desc"]
      )
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll)
    window.scroll(0, 0)

    this.objQuery.period = this.defaultPeriod
    this.mixins_global_getIndiceFilter(this.objQuery)
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    ...mapActions("indice", ["setReturnPeriod"]),
    handleScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      currentScrollPosition > 0 ? (this.shouldStick = true) : (this.shouldStick = false)
      this.$emit("current-scroll", currentScrollPosition)
    },
    async insertQs(val, alias) {
      if (alias == "period") {
        this.objQuery.period = val
      }
      this.setReturnPeriod(this.objQuery.period)
    }
  }
}
</script>

<style lang="scss" scoped>
.top-sticky {
  .select-period-row {
    padding-top: 48px;
  }
}
#section-list-indice {
  // @extend %container-style;
  padding-right: 0px;
  padding-left: 0px;
}
#search-loading {
  @extend %container-style;
  text-align: center;
  vertical-align: middle;
  .loading {
    text-align: center;
    font-size: 32px;
    margin: 50px auto auto;
    color: #bababa;
  }
}
.sticky-top {
  position: sticky;
  top: 49px;
}
.remove-sticky-top {
  position: relative;
}
</style>
